import { createContext } from 'react';

export interface ConsentContextValue {
  analyticsAllowed: boolean | null;
}

export const ConsentContext = createContext<ConsentContextValue>({ analyticsAllowed: null });

export interface IubendaWindow {
  _iub?: {
    cs?: {
      consent?: {
        purposes?: Record<string, boolean>;
      };
      ui?: {
        openPreferences?: () => void;
      };
    };
  };
}

export function getIubendaConsent(): boolean | null {
  if (typeof window === 'undefined') return null;

  const iub = (window as unknown as IubendaWindow)._iub;
  const purposes = iub?.cs?.consent?.purposes;
  if (!purposes) return null;

  const analytics = purposes['4'];
  return typeof analytics === 'boolean' ? analytics : null;
}

export function openIubendaPreferences(): void {
  if (typeof window === 'undefined') return;

  const iub = (window as unknown as IubendaWindow)._iub;
  if (!iub?.cs?.ui?.openPreferences) return;

  try {
    iub.cs.ui.openPreferences();
  } catch (error) {
    console.warn('Failed to open Iubenda preferences:', error);
  }
}
